// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TreatmentCDA_TreatmentCDA__hHqo1 {
  width: 100%;
  height: 73vh;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #F0F2F5;
}
.TreatmentCDA_TreatmentCDA__hHqo1 .TreatmentCDA_content__sqwVe {
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 4px;
}
.TreatmentCDA_TreatmentCDA__hHqo1 .TreatmentCDA_CDARedactorWrapper__B801\\+,
.TreatmentCDA_TreatmentCDA__hHqo1 .TreatmentCDA_xPathesWrapper__e1p-n {
  max-width: 50%;
  flex: 1 1;
}`, "",{"version":3,"sources":["webpack://./src/components/modules/tables/components/DocumentProcessing/TreatmentCDA/TreatmentCDA.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AACF;AACE;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,QAAA;AACJ;AAEE;;EAEE,cAAA;EACA,SAAA;AAAJ","sourcesContent":[".TreatmentCDA {\n  width: 100%;\n  height: 73vh;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  background: #F0F2F5;\n\n  .content {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    gap: 4px;\n  }\n\n  .CDARedactorWrapper,\n  .xPathesWrapper {\n    max-width: 50%;\n    flex: 1 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"TreatmentCDA": `TreatmentCDA_TreatmentCDA__hHqo1`,
	"content": `TreatmentCDA_content__sqwVe`,
	"CDARedactorWrapper": `TreatmentCDA_CDARedactorWrapper__B801+`,
	"xPathesWrapper": `TreatmentCDA_xPathesWrapper__e1p-n`
};
export default ___CSS_LOADER_EXPORT___;
